// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbuttons {
  cursor: pointer;
  color: #111111;
}

.navbuttonsMobile {
  font-size: 8pt;
  cursor: pointer;
  color: #111111;
}

.hasNoSuccessor, .hasNoPredecessor {
  color: #ddd;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/graphics/job-satisfactions-team-graph/job-satisfactions-team-graph.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,cAAA;AACJ;;AAEA;EACI,cAAA;EACA,eAAA;EACA,cAAA;AACJ;;AAEA;EACI,WAAA;AACJ","sourcesContent":[".navbuttons {\n    cursor: pointer;\n    color: #111111;\n}\n\n.navbuttonsMobile {\n    font-size: 8pt;\n    cursor: pointer;\n    color: #111111;\n}\n\n.hasNoSuccessor, .hasNoPredecessor {\n    color: #ddd;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
